const API_BASE_URL = process.env.REACT_APP_API_END_POINT;

export default API_BASE_URL;